import { useContext, useEffect, useState } from 'react'
import { Edit, TrashAlt } from '@styled-icons/boxicons-solid'

import Button from '../../common/Button'
import InputText from '../../common/InputText'
import LinkWithStatus from '../../common/LinkWithStatus'
import {
  SET_SELECTED_SHIFTS_DATA,
  SET_SHIFTS_DATA,
  ShiftsContext,
  SHOW_SHIFTS_FORM,
} from './context/context'
import { NavContext } from '../../../context/global_context'
import Tooltip from '../../common/tooltip'
import Pagination from '../../common/Pagination'
import NoRecordsFound from '../../common/NoRecordsFound'
import { deleteRequest, getRequest } from '../../../services/base'
import { downloadFileBlob } from '../../../utils/common'
import ShiftForm from './form'

const ShiftRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 pl-10 items-center table_text">
          <Tooltip message={props.plant?.name}>
            <div>{props.plant?.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-5/12 pl-6 items-center table_text">
          <Tooltip message={props?.name}>
            <div>{props.name}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.start_time}>
            <div>{props.start_time}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.end_time}>
            <div>{props.end_time}</div>
          </Tooltip>
        </div>

        <div className="flex w-2/12 pl-6 justify-end ">
          <div>
            <span
              onClick={() => {
                props.onEdit()
              }}
              className="cursor-pointer p-2"
            >
              <Edit size="2rem" color="#0189E9" />
            </span>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2"
            >
              <TrashAlt size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

const Shifts = () => {
  const [state, dispatch] = useContext(ShiftsContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [searchValue, setSearchValue] = useState('')
  const [pagination, setPagination] = useState({})

  useEffect(() => {
    getShiftsData('', true)
  }, [])

  const deleteShift = async (id, name) => {
    if (
      window.confirm(`Are you sure want to delete selected ${name}`) === true
    ) {
      let res = await deleteRequest(`/api/shift/${id}/`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Shift Deleted Successfully`,
        },
      })
      getShiftsData('', false)
      dispatch({
        type: SET_SELECTED_SHIFTS_DATA,
        data: {},
        showFormPopup: false,
      })
    }
  }

  const getShiftsData = async (url = null, showLoader = false) => {
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Fetching Shifts Data',
          showLoader: true,
        },
        notification: {},
      })
    }

    let res = await getRequest(url ? url : `/api/shift/?search=${searchValue}`)
    dispatch({ type: SET_SHIFTS_DATA, data: res.results })
    setPagination(res.pagination)
    if (showLoader) {
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })
    }
  }

  const downloadShift = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: `Downloading Shift csv file is in progress.`,
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(`/api/shift/download/`, true, true)
    if (res?.msg) {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    } else {
      downloadFileBlob(res, `shifts.csv`)
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: 'File Download completed.',
        },
      })
    }
  }

  return (
    <div>
      <ShiftForm
        getShiftList={() => {
          getShiftsData('', false)
        }}
      />
      <form
        className="flex flex-col w-full space-y-2 pb-5"
        acceptCharset="UTF-8"
        onSubmit={(e) => {
          e.preventDefault()
        }}
      >
        <div className="flex space-x-5">
          <div className="flex w-6/12 font-light text-right space-x-5">
            <InputText
              name="search"
              value={searchValue}
              type="text"
              placeholder={`Enter To Search Shift`}
              onChange={(e) => {
                setSearchValue(e)
              }}
              wrapperClass={`p-0`}
              isFullSize={false}
              className="h-10 px-5 pr-5"
              isRequired={false}
            />
            <Button
              className={`bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded`}
              onClick={() => {
                getShiftsData('', true)
              }}
              text="Search"
            />
          </div>
          <div className="flex w-6/12 font-light text-right space-x-5 justify-end">
            <LinkWithStatus
              href={`/administration/shift/export`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Export Shift"
              onClickFunc={() => {
                downloadShift()
              }}
            />
            <LinkWithStatus
              href={`/administration/shift/new`}
              className={
                'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
              }
              title="Create New Shift"
              onClickFunc={() => {
                dispatch({
                  type: SHOW_SHIFTS_FORM,
                  data: {},
                  showFormPopup: true,
                })
              }}
            />
          </div>
        </div>
      </form>
      <div className="font-light">
        <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
          <div className="flex w-3/12 pl-10 items-center">Plant</div>
          <div className="flex w-5/12 pl-6 items-center">Name</div>
          <div className="flex w-1/12 pl-6 items-center">Start Time</div>
          <div className="flex w-1/12 pl-6 items-center">End Time</div>
          <div className="w-2/12 pl-6"></div>
        </div>
      </div>
      {state?.data?.map((shift, index) => {
        return (
          <ShiftRow
            key={`shift-${shift.id}-${index}`}
            {...shift}
            onEdit={() => {
              dispatch({
                type: SET_SELECTED_SHIFTS_DATA,
                data: { ...shift, index: index },
                showFormPopup: true,
              })
            }}
            onDelete={() => {
              deleteShift(shift.id, shift.name)
            }}
          />
        )
      })}
      {state?.data?.length < 1 && <NoRecordsFound />}
      <div className="py-6">
        <Pagination
          context={pagination}
          onClickNext={(e) => {
            getShiftsData(e, true)
          }}
          onClickPrev={(e) => {
            getShiftsData(e, true)
          }}
        />
      </div>
    </div>
  )
}

export default Shifts
